import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import { ExperienceColorMode } from '@/types/gql.generated';
import {
  resolveCategoryOptionColors,
  toPaletteColorName,
  type CategoryOptionColors,
} from '../lib/paletteLookup';

/**
 * A category's chip fill (background/hover/text) in the light (100) wash,
 * resolved through the surrounding experience's colorPalette — child planner
 * pages resolve the parent's. Must render within a PageExperienceContext.
 *
 * Deliberately ignores the experience's colorMode — the accessor for chips that
 * pair a pale pill with a full-strength swatch, where BOLD would resolve the pill
 * to the same 500 as the swatch and swallow it. Anything that should follow the
 * experience's own mode wants useCategoryOptionColorsResolver instead. Pairs with
 * useBoldCategoryColor.
 */
export const useLightCategoryOptionColors = (
  colorName: string | null | undefined
): CategoryOptionColors => {
  const context = usePageExperienceContext();
  const experience = context.parentExperience ?? context.experience;

  return resolveCategoryOptionColors(
    toPaletteColorName(colorName),
    experience.colorPalette,
    ExperienceColorMode.Light
  );
};
